import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/sections/Footer';
import MaisonSection from '../components/sections/MaisonSection';
import NotreHistoire from '../components/sections/NotreHistoire';

export default function MaisonPage() {
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#111111]" data-testid="maison-page">
      <Navbar />
      <main>
        <MaisonSection asPage />
        <NotreHistoire />
      </main>
      <Footer />
    </div>
  );
}
